import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { FormRs005Build } from './forms-build/form-rs005-build';

export class FormRs005 extends FormRs005Build {
    public CreateForm(formBuilder: FormBuilder): FormGroup {
        const formulario: FormGroup = formBuilder.group({
            id: [0, []],
            offline: true,
            /* Card I - Dados Cerar*/
            cerar: ['', [Validators.required]],
            site_recebimento: ['', []],
            safra: ['', []],
            data_despalha: ['', []],
            hibrido_rnc: ['', []],
            gleba: ['', []],
            contrato_juridico: ['', []],
            numero_campo: ['', []],
            peso_liq_carga_cooperante_kg: ['', []],
            peso_amostra_cooperante_g: ['', []],
            peso_palha_cooperante_g: ['', []],
            peso_impureza_cooperante_g: ['', []],
            peso_sabugo_cooperante_g: ['', []],
            peso_semente_cooperante_g: ['', []],
            umidade_prc: ['', []],

            /* Card II - Avaliação de Granação*/
            total_espigas_granacao: ['', []],
            granacao_cem_prc: ['', []],
            granacao_setenta_cinco_prc: ['', []],
            granacao_cinquenta_prc: ['', []],
            granacao_vinte_cinco_prc: ['', []],
            granacao_zero_prc: ['', []],
            granacao_media_prc: ['', []],

            /* Card III - Amostra na Esteira Transportadora*/
            status_wwb: ['', []],
            peso_amostra_g: ['', []],
            peso_palha_mais_impureza_g: ['', []],
            peso_graos_debulhados_g: ['', []],
            peso_graos_espigas_inteiras_g: ['', []],
            palha_cerar_prc: ['', []],
            sabugo_cerar_prc: ['', []],
            semente_cerar_prc: ['', []],
            palha_amostra_prc: ['', []],
            total_graos_perdidos_amostra_prc: ['', []],
            esteira_perda_espigas_inteiras_prc: ['', []],

            /*Card IV - Calculos de Peso*/
            peso_palha_carga_kg: ['',[]],
            peso_liq_carga_com_umidade_kg: ['', []],
            perda_processo_kg: ['', []],
            peso_espigas_inteiras_perdidas_kg: ['', []],

            /*Card V - Perda na Despalha*/
            depalha_perda_espigas_inteiras_prc: ['', []],
            perda_graos_debulhados_despalha_prc: ['', []],
            perda_total_despalha_prc: ['', []],

            /*Card VI - Ear Sorter*/
            total_espigas_avaliadas_retorno: ['', []],
            numero_espigas_despalhadas_retorno: ['', []],
            total_espigas_avaliadas_mesa: ['', []],
            numero_espigas_com_palha_mesa: ['', []],
            espigas_despalhadas_retorno_prc: ['', []],
            espigas_com_palha_mesa_selecao_prc: ['', []],

            /*Card VII - Descarte da Mesa de Seleção*/
            // umidade_prc: ['', []],
            peso_liq_carga_sem_palha_carga_kg: ['', []],
            peso_espigas_atipicas_kg: ['', []],
            peso_espigas_fora_do_padrao_kg: ['', []],
            peso_descarte_mesa_selecao_kg: ['', []],
            descarte_mesa_selecao_prc: ['', []],
            espigas_atipicas_prc: ['', []],
            presenca_outras_sementes: ['', []],

            /* Card VIII - Avaliação das Despalhadoras*/
            configuracao_rolos: ['', []],
            tipo_calha: ['', []],
            recobrimento_rolos_prc: ['', []],
            num_espigas_totais_primeira_contagem: ['', []],
            num_espigas_com_palha_primeira_contagem: ['', []],
            num_espigas_totais_segunda_contagem: ['', []],
            num_espigas_com_palha_segunda_contagem: ['', []],
            peso_medio_espigas_com_palha_g: ['', []],
            despalha_prc: ['', []],
            espigas_com_palha_prc: ['', []],
            apc_ligado: ['',[]],

            /*Card IX - Observações*/
            linha_descarga: ['', []],
            observacao: ['', []],
            turno_amostragem: ['', []],
            created_by: ['', []],
            responsavel_amostragem: ['', []],
            responsavel_lancamento: ['', []],

            /* Card X - Avaliação de Morte Prematura*/
            total_espigas_morte_prematura: ['', []],
            morte_prematura_prc: ['', []],

            /* Card XI - Avaliação de Outros Defeitos*/
            total_espigas_outros_defeitos: ['', []],
            tipo_defeito: ['', []],
            outros_defeitos_prc: ['', []],

            /*PréBasica*/
            safra_basica: ['', []],
            geracao: ['', []],
            numero_caixa: ['', []],
            lote_rw: ['', []],
            tipo_colheita: ['', []],
            site_origem: ['', []],
            peso_rw: ['', []],
            peso_pos_secagem: ['', []],
            inicio_selecao_data_hora: ['', []],
            fim_selecao_data_hora: ['', []],
            motivo_parada_resselecao: ['', []],
            tempo_parada_selecao_hora: ['', []],
            caixa_pos_mesa: ['', []],
            peso_pos_mesa: ['', []],
            resselecao: ['', []],
            ataque_lagartas: ['', []],
            diploidia: ['', []],
            fusarium: ['', []],
            ataque_besouros: ['', []],
            viviparidade: ['', []],
            giberela: ['', []],
            mortas: ['', []],
            popped_kernel: ['', []],
            ponto_dupla: ['', []],
            comentarios: ['', []],
            lote_ds: ['', []],
            numero_caixa_debulha: ['', []],
            inicio_debulha_data_hora: ['', []],
            umidade_debulha_prc: ['', []],
            numero_bag_iniciado: ['', []],
            numero_bag_finalizado: ['', []],
            peso_bruto_bag_finalizado: ['', []],
            peso_liquido_bag_finalizado: ['', []],
            motivo_parada_debulha: ['', []],
            tempo_parada_debulha_hora: ['', []],
            fim_debulha_data_hora: ['', []],
            limpeza_manual: ['', []],
            inicio_limpeza_manual_data_hora: ['', []],
            fim_limpeza_manual_data_hora: ['', []],
            selecao_horas: ['', []],
            debulhas_horas: ['', []],
            tempo_atraso_secagem: ['', []],
            tempo_atraso_selecao: ['', []],
            tempo_parada_selecao: ['', []],
            tempo_parada_debulha: ['', []],
            houve_troca_caixa: ['', []],
            novo_numero_caixa: ['', []],
            nota_granacao: ['', []],
            desgrana_mesa: ['', []],
            viviparidade_selecao: ['', []],
            popped_kernel_selecao: ['', []],
            ataque_fungos: ['', []],
            ataque_lagartas_select: ['', []],
            morte_prematura_select: ['', []],
            list_source: ['', []],
            faixa_vermelha: ['', []],
            faixa_marrom: ['', []],
            faixa_laranja: ['', []],
            faixa_cinza: ['', []],
            lote_pa: ['', []],
            peso_pa_bruto: ['', []],
            peso_pa_liquido: ['', []],
            descarte_pa: ['', []],
            numero_sacos: ['', []],
            nota_ardida: ['', []],
            controle_caixa: ['', []],
            cerar_basica: ['', []]
        });
        return formulario;
    }
}
